import React from 'react';
import { IconProps } from '.';

const SvgColoredThumbsUp = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFC700'
        d='m7.274 9.324 2.714-6.7c.153-.377.524-.642.924-.57 1.062.192 1.97.961 1.588 3.446l-.342 3.33c.416.01.82.018 1.215.025 4.252.08 7.192.135 7.869 2.318.111.239.178.5.178.78a1.84 1.84 0 0 1-.695 1.434c.33.335.534.793.534 1.298 0 .695-.39 1.295-.959 1.612.24.311.387.697.387 1.12 0 .693-.389 1.292-.955 1.61.24.312.387.697.387 1.12 0 1.022-.83 1.853-1.851 1.853H8.243c-1.13 0-1.523-.315-1.9-.618-.292-.233-.574-.46-1.179-.528-1.432-.16-1.532-1.14-1.532-2.158v-5.955c0-1.367.72-1.621 1.576-1.924.705-.25 1.502-.53 2.066-1.493Z'
      />
      <path
        fill='#FFA800'
        d='M14.789 13.805h4.78c.65 0 1.26-.348 1.592-.907a.486.486 0 0 0-.837-.496.882.882 0 0 1-.756.43h-4.894a.88.88 0 0 1 0-1.758h2.27a.486.486 0 0 0 0-.972h-2.27c-1.022 0-1.852.83-1.852 1.851 0 .57.264 1.074.67 1.414a1.844 1.844 0 0 0-.555 1.318c0 .571.265 1.077.673 1.416a1.843 1.843 0 0 0 .233 2.822 1.837 1.837 0 0 0-.474 1.225c0 1.02.831 1.851 1.852 1.851h3.047c.65 0 1.26-.347 1.592-.906a.486.486 0 0 0-.835-.497.886.886 0 0 1-.757.431H15.22a.88.88 0 0 1 0-1.759h3.614a1.86 1.86 0 0 0 1.593-.907.486.486 0 1 0-.835-.497.873.873 0 0 1-.758.432h-3.923a.88.88 0 0 1 0-1.76h4.495c.65 0 1.26-.347 1.592-.906a.486.486 0 0 0-.835-.497.874.874 0 0 1-.757.431h-4.618a.88.88 0 0 1 0-1.76Z'
      />
    </svg>
  );
};

export default SvgColoredThumbsUp;
